import { useEffect } from 'react';
import { notificationCenterActions } from '../../store';

const { FETCH_NOTIFICATIONS_INITIAL_DATA } = notificationCenterActions;

export const useNotificationsInitialData = () => {
  useEffect(() => {
    FETCH_NOTIFICATIONS_INITIAL_DATA();
  }, [FETCH_NOTIFICATIONS_INITIAL_DATA]);

  return null;
};
